import type { Row } from "@tanstack/react-table"

export const sortEmptyLast = <T>(rowA: Row<T>, rowB: Row<T>, columnId: string): number => {
  const a = rowA.getValue<string>(columnId)
  const b = rowB.getValue<string>(columnId)
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  return a.localeCompare(b)
}
